import {
  getBrandPart,
  getCategoryPart,
  getMemberName,
} from '../../meta/pageData'

export const getMetaTitle = (
  member: {
    nick_name: string
    shop: { name: string } | null
  },
  itemCategoryName?: string,
  itemChildCategoryName?: string,
  itemBrandName?: string | null
) => {
  const memberName = getMemberName(member)
  const brandName = getBrandPart(itemBrandName)
  const categoryName = getCategoryPart(itemCategoryName, itemChildCategoryName)

  return `${memberName}｜${brandName}${categoryName}を使ったコーディネート`
}
